import { Component, OnInit, Inject, EventEmitter, Pipe, DebugElement } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlassService } from '@core/model/glassService.model';
import { ConfigService } from '@core/model/configService.model';
import { GlassInfo } from '@core/model/glassInfo.model';
import { ModelInfo } from '@core/model/modelInfo.model';
import { VilaxInfo } from '@core/model/vilaxInfo.model';

@Component({
  selector: 'app-modal-config-services',
  templateUrl: './modal-config-services.component.html',
  styleUrls: ['./modal-config-services.component.scss']
})

export class ModalConfigServicesComponent implements OnInit {
  labelTitile: string;
  service: GlassService;
  ConfigService: ConfigService;
  ModelInfoModel: ModelInfo;
  VilaxInfoModel: VilaxInfo;
  GlassInfoModel: GlassInfo;
  glassWidht: number;
  glassHeight: number;
  widht: string;
  height: string;
  msjErrorEsquinas: string = 'Max: 100';
  constructor(
    public dialogRef: MatDialogRef<ModalConfigServicesComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMessage: any,
    ) {

    if (this.dataMessage !== null && this.dataMessage !== undefined) {
      this.labelTitile = this.dataMessage.labelTitile;
      this.service = this.dataMessage.service;
      this.ConfigService = this.dataMessage.configService;
      this.ModelInfoModel = this.dataMessage.ModelInfoModel;

      if (this.ModelInfoModel.vModelo === 'VIDRIO CORTADO') {
        this.GlassInfoModel = this.ModelInfoModel as GlassInfo;
      } else if (this.ModelInfoModel.vModelo === 'VILAX') {
        this.VilaxInfoModel = this.ModelInfoModel as VilaxInfo;
      }

      this.glassWidht = Number(this.dataMessage.widht);
      this.glassHeight = Number(this.dataMessage.height);
    } else {
      this.labelTitile = 'Lo sentimos parece que algo anda mal';
    }
  }

  ngOnInit() {
    this.ConfigService.vCodigoArticulo = this.service.ItemId;
    this.widht = 33 + 'vh';
    this.height = 33 + 'vh';
  }

  configService(attributeName: string, marked: boolean) {
    let vidrioTmp: GlassInfo;

    if (this.service.FixedRadius) {
      if (marked)
        this.changeCornerValue(this.service.RadiusSize, attributeName);
      else 
        this.changeCornerValue(0, attributeName);
    } else {
      if (attributeName === 'Widht1') {
        if (marked === true) {
          this.ConfigService.vAncho1 = this.glassWidht;

          if (this.GlassInfoModel !== undefined) {
            this.GlassInfoModel.vSideTop = this.ConfigService.vCodigoArticulo;
              
          } else if (this.VilaxInfoModel !== undefined) {
            this.VilaxInfoModel.vSideTop = this.ConfigService.vCodigoArticulo;
            this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
              vidrioTmp = CapaTmp.vModelo as GlassInfo;
              vidrioTmp.vSideTop = this.ConfigService.vCodigoArticulo;
              vidrioTmp.vListaServicios.forEach(servicioTmp => {
                if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                  servicioTmp.vAncho1 = this.glassWidht;
                }
              });
            });
          }
        } else {
          this.ConfigService.vAncho1 = 0;
          if (this.GlassInfoModel !== undefined) {
            this.GlassInfoModel.vSideTop = '';
          } else if (this.VilaxInfoModel !== undefined) {
            this.VilaxInfoModel.vSideTop = '';
            this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
              vidrioTmp = CapaTmp.vModelo as GlassInfo;
              vidrioTmp.vSideTop = '';
              vidrioTmp.vListaServicios.forEach(servicioTmp => {
                if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                  servicioTmp.vAncho1 = 0;
                }
              });
            });
          }
        }
      } else if (attributeName === 'Widht2') {
        if (marked === true) {
          this.ConfigService.vAncho2 = this.glassWidht;
            
          if (this.GlassInfoModel !== undefined) {
            this.GlassInfoModel.vSideBottom = this.ConfigService.vCodigoArticulo;
          } else if (this.VilaxInfoModel !== undefined) {
            this.VilaxInfoModel.vSideBottom = this.ConfigService.vCodigoArticulo;
            this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
              vidrioTmp = CapaTmp.vModelo as GlassInfo;
              vidrioTmp.vSideBottom = this.ConfigService.vCodigoArticulo;
              vidrioTmp.vListaServicios.forEach(servicioTmp => {
                if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                  servicioTmp.vAncho2 = this.glassWidht;
                }
              });
            });
          }
        } else {
          this.ConfigService.vAncho2 = 0;

          if (this.GlassInfoModel !== undefined) {
            this.GlassInfoModel.vSideBottom = '';
          } else if (this.VilaxInfoModel !== undefined) {
            this.VilaxInfoModel.vSideBottom = '';
            this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
              vidrioTmp = CapaTmp.vModelo as GlassInfo;
              vidrioTmp.vSideBottom = '';
              vidrioTmp.vListaServicios.forEach(servicioTmp => {
                if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                  servicioTmp.vAncho2 = 0;
                }
              });
            });
          }
        }
      } else if (attributeName === 'Height1') {
        if (marked === true) {
          this.ConfigService.vAlto1 = this.glassHeight;

          if (this.GlassInfoModel !== undefined) {
            this.GlassInfoModel.vSideLeft = this.ConfigService.vCodigoArticulo;
          } else if (this.VilaxInfoModel !== undefined) {
            this.VilaxInfoModel.vSideLeft = this.ConfigService.vCodigoArticulo;
            this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
              vidrioTmp = CapaTmp.vModelo as GlassInfo;
              vidrioTmp.vSideLeft = this.ConfigService.vCodigoArticulo;
              vidrioTmp.vListaServicios.forEach(servicioTmp => {
                if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                  servicioTmp.vAlto1 = this.glassHeight;
                }
              });
            });
          }
        } else {
          this.ConfigService.vAlto1 = 0;

          if (this.GlassInfoModel !== undefined) {
            this.GlassInfoModel.vSideLeft = '';
          } else if (this.VilaxInfoModel !== undefined) {
            this.VilaxInfoModel.vSideLeft = '';
            this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
              vidrioTmp = CapaTmp.vModelo as GlassInfo;
              vidrioTmp.vSideLeft = '';
              vidrioTmp.vListaServicios.forEach(servicioTmp => {
                if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                  servicioTmp.vAlto1 = 0;
                }
              });
            });
          }
        }
      } else if (attributeName === 'Height2') {
        if (marked === true) {
          this.ConfigService.vAlto2 = this.glassHeight;

          if (this.GlassInfoModel !== undefined) {
            this.GlassInfoModel.vSideRight = this.ConfigService.vCodigoArticulo;
          } else if (this.VilaxInfoModel !== undefined) {
            this.VilaxInfoModel.vSideRight = this.ConfigService.vCodigoArticulo;
            this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
              vidrioTmp = CapaTmp.vModelo as GlassInfo;
              vidrioTmp.vSideRight = this.ConfigService.vCodigoArticulo;
              vidrioTmp.vListaServicios.forEach(servicioTmp => {
                if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                  servicioTmp.vAlto2 = this.glassHeight;
                }
              });
            });
          }
        } else {
          this.ConfigService.vAlto2 = 0;

          if (this.GlassInfoModel !== undefined) {
            this.GlassInfoModel.vSideRight = '';
          } else if (this.VilaxInfoModel !== undefined) {
            this.VilaxInfoModel.vSideRight = '';
            this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
              vidrioTmp = CapaTmp.vModelo as GlassInfo;
              vidrioTmp.vSideRight = '';
              vidrioTmp.vListaServicios.forEach(servicioTmp => {
                if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                  servicioTmp.vAlto2 = 0;
                }
              });
            });
          }
        }
      }
    }
  }

  onInputKeyup(value, attributeName) {
    this.changeCornerValue(value, attributeName);
  }

  changeCornerValue(value, attributeName) {
    let vidrioTmp: GlassInfo;
    let radioFijo;
    if (this.service.FixedRadius) {
      radioFijo = this.service.RadiusSize;
    }
    if (radioFijo) {
      if (attributeName === 'Widht1') {
        this.ConfigService.vAncho1 = value;
      } else if (attributeName === 'Widht2') {
        this.ConfigService.vAncho2 = value;
      } else if (attributeName === 'Height1') {
        this.ConfigService.vAlto1 = value;
      } else if (attributeName === 'Height2') {
        this.ConfigService.vAlto2 = value;
      }
    } /*else {
      if (attributeName === 'Widht1' && value > 100) {
        this.ConfigService.vAncho1 = 100;
      } else if (attributeName === 'Widht2' && value > 100) {
        this.ConfigService.vAncho2 = 100;
      } else if (attributeName === 'Height1' && value > 100) {
        this.ConfigService.vAlto1 = 100;
      } else if (attributeName === 'Height2' && value > 100) {
        this.ConfigService.vAlto2 = 100;
      }
    }*/

    if (attributeName === 'Widht1' && value === null) {
      this.ConfigService.vAncho1 = 0;
    } else if (attributeName === 'Widht2' && value === null) {
      this.ConfigService.vAncho2 = 0;
    } else if (attributeName === 'Height1' && value === null) {
      this.ConfigService.vAlto1 = 0;
    } else if (attributeName === 'Height2' && value === null) {
      this.ConfigService.vAlto2 = 0;
    }

    if (attributeName === 'Widht1') {
      if (value > 0) {
        if (this.GlassInfoModel !== undefined) {
          this.GlassInfoModel.vCornerBR = this.ConfigService.vCodigoArticulo;
        } else if (this.VilaxInfoModel !== undefined) {
          this.VilaxInfoModel.vCornerBR = this.ConfigService.vCodigoArticulo;
          this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
            vidrioTmp = CapaTmp.vModelo as GlassInfo;
            vidrioTmp.vCornerBR = this.ConfigService.vCodigoArticulo;
            vidrioTmp.vListaServicios.forEach(servicioTmp => {
              if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                servicioTmp.vAncho1 = this.ConfigService.vAncho1;
              }
            });
          });
        }
      } else {
        if (this.GlassInfoModel !== undefined) {
          this.GlassInfoModel.vCornerBR = '';
        } else if (this.VilaxInfoModel !== undefined) {
          this.VilaxInfoModel.vCornerBR = '';
          this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
            vidrioTmp = CapaTmp.vModelo as GlassInfo;
            vidrioTmp.vCornerBR = '';
            vidrioTmp.vListaServicios.forEach(servicioTmp => {
              if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                servicioTmp.vAncho1 = 0;
              }
            });
          });
        }
      }
    }

    if (attributeName === 'Widht2') {
      if (value > 0) {
        if (this.GlassInfoModel !== undefined) {
          this.GlassInfoModel.vCornerTL = this.ConfigService.vCodigoArticulo;
        } else if (this.VilaxInfoModel !== undefined) {
          this.VilaxInfoModel.vCornerTL = this.ConfigService.vCodigoArticulo;
          this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
            vidrioTmp = CapaTmp.vModelo as GlassInfo;
            vidrioTmp.vCornerTL = this.ConfigService.vCodigoArticulo;
            vidrioTmp.vListaServicios.forEach(servicioTmp => {
              if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                servicioTmp.vAncho2 = this.ConfigService.vAncho2;
              }
            });
          });
        }
      } else {
        if (this.GlassInfoModel !== undefined) {
          this.GlassInfoModel.vCornerTL = '';
        } else if (this.VilaxInfoModel !== undefined) {
          this.VilaxInfoModel.vCornerTL = '';
          this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
            vidrioTmp = CapaTmp.vModelo as GlassInfo;
            vidrioTmp.vCornerTL = '';
            vidrioTmp.vListaServicios.forEach(servicioTmp => {
              if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                servicioTmp.vAncho2 = 0;
              }
            });
          });
        }
      }
    }

    if (attributeName === 'Height1') {
      if (value > 0) {
        if (this.GlassInfoModel !== undefined) {
          this.GlassInfoModel.vCornerBL = this.ConfigService.vCodigoArticulo;
        } else if (this.VilaxInfoModel !== undefined) {
          this.VilaxInfoModel.vCornerBL = this.ConfigService.vCodigoArticulo;
          this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
            vidrioTmp = CapaTmp.vModelo as GlassInfo;
            vidrioTmp.vCornerBL = this.ConfigService.vCodigoArticulo;
            vidrioTmp.vListaServicios.forEach(servicioTmp => {
              if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                servicioTmp.vAlto1 = this.ConfigService.vAlto1;
              }
            });
          });
        }
      } else {
        if (this.GlassInfoModel !== undefined) {
          this.GlassInfoModel.vCornerBL = '';
        } else if (this.VilaxInfoModel !== undefined) {
          this.VilaxInfoModel.vCornerBL = '';
          this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
            vidrioTmp = CapaTmp.vModelo as GlassInfo;
            vidrioTmp.vCornerBL = '';
            vidrioTmp.vListaServicios.forEach(servicioTmp => {
              if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                servicioTmp.vAlto1 = 0;
              }
            });
          });
        }
      }
    }

    if (attributeName === 'Height2') {
      if (value > 0) {
        if (this.GlassInfoModel !== undefined) {
          this.GlassInfoModel.vCornerTR = this.ConfigService.vCodigoArticulo;
        } else if (this.VilaxInfoModel !== undefined) {
          this.VilaxInfoModel.vCornerTR = this.ConfigService.vCodigoArticulo;
          this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
            vidrioTmp = CapaTmp.vModelo as GlassInfo;
            vidrioTmp.vCornerTR = this.ConfigService.vCodigoArticulo;
            vidrioTmp.vListaServicios.forEach(servicioTmp => {
              if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                servicioTmp.vAlto2 = this.ConfigService.vAlto2;
              }
            });
          });
        }
      } else {
        if (this.GlassInfoModel !== undefined) {
          this.GlassInfoModel.vCornerTR = '';
        } else if (this.VilaxInfoModel !== undefined) {
          this.VilaxInfoModel.vCornerTR = '';
          this.VilaxInfoModel.vListaLuzCapa.forEach(CapaTmp => {
            vidrioTmp = CapaTmp.vModelo as GlassInfo;
            vidrioTmp.vCornerTR = '';
            vidrioTmp.vListaServicios.forEach(servicioTmp => {
              if (servicioTmp.vCodigoArticulo === this.ConfigService.vCodigoArticulo) {
                servicioTmp.vAlto2 = 0;
              }
            });
          });
        }
      }
    }
  }

  close() {
    this.dialogRef.close();
  }

  validateCornersValue() {
    let ret = true;

    if (!this.service.FixedRadius) {
      if (this.ConfigService.vAncho1 > 100
      || this.ConfigService.vAlto1 > 100
      || this.ConfigService.vAncho2 > 100
      || this.ConfigService.vAlto2 > 100) {
        ret = false;
      }
    }

    return ret;
  }

  allowClose() {
    let ret = true;
    
    if(this.service.Nature === 5) {
      ret = this.validateCornersValue();
    }
    
    return ret;
  }
}
